import script from "./VisualizadorDocumentoCobranca.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizadorDocumentoCobranca.vue?vue&type=script&setup=true&lang=js"

import "./VisualizadorDocumentoCobranca.vue?vue&type=style&index=0&id=487a8abc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487a8abc"]])

export default __exports__